import { Box, IconButton, Typography } from '@mui/material';
import {
  GridFooterContainer,
  GridSelectedRowCount,
  selectedGridRowsCountSelector,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid-pro';
import { GridOff } from 'mdi-material-ui';
import { useConfirmDialog } from 'src/@core/hooks/useConfirmDialog';
import { useVigoTranslation } from 'src/@core/hooks/useVigoTranslation';
import { VigoTooltip } from '../../vigo-tooltip';
import { CustomFooterExtendedProps } from '../datagrid-types';
import { memo, useCallback } from 'react';

const CustomFooter = ({
  currentLoadedRowsSize,
  totalRowSize,
  resetLayout,
  defaultGridState,
  disableLayoutReset,
  multiSelect
}: CustomFooterExtendedProps) => {
  // Hooks
  const { t } = useVigoTranslation();
  const { set } = useConfirmDialog();
  const apiRef = useGridApiContext();

  const selectedRowCount = useGridSelector(apiRef, selectedGridRowsCountSelector);

  const resetGrid = useCallback(() => {
    set(
      'Are you sure you wish to reset grid?',
      () => {
        resetLayout?.();
      },
      undefined,
      'this action cannot be undone'
    );
  }, [resetLayout, set]);

  return (
    <GridFooterContainer>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {defaultGridState && !disableLayoutReset && (
          <VigoTooltip title="Reset grid to default layout">
            <IconButton onClick={resetGrid} sx={{ cursor: 'pointer' }}>
              <GridOff> </GridOff>
            </IconButton>
          </VigoTooltip>
        )}
        {multiSelect && selectedRowCount > 0 && <GridSelectedRowCount selectedRowCount={selectedRowCount} />}
      </Box>
      <Typography sx={{ pr: '35px' }}>
        {t('Showing')} {currentLoadedRowsSize} {t('of')} {totalRowSize} {t('rows')}
      </Typography>
    </GridFooterContainer>
  );
};

export default memo(CustomFooter);
